// extracted by mini-css-extract-plugin
module.exports = {"CustomerLogo":"Start_CustomerLogo__3bqi6","Container":"Start_Container__2TLaR","WelcomeText":"Start_WelcomeText__2FHbs"};